// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-C":"C_cost-saving-C__s6A17"};